import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";

interface Props {
  setAllCountries: (countries: []) => any;
}
function DTOEmergencyContactModal({ setAllCountries }: Props) {
  async function getAllCountries() {
    const response = await commonServices.getCountries();
    if (response) {
      const { data }: any = response;
      setAllCountries(data);
    }
  }
  useEffect(() => {
    getAllCountries();
  }, []);
  return <></>;
}
export default DTOEmergencyContactModal;
